<div>
  <h1>{{'RESULTS.SECTIONS.BASELINE_DEBT_SCHEDULE' | anessaTranslation: trigger}}</h1>
  <!--START SELECTION BOXES-->
  <div class="row fl">
    <!-- Table/Graph Select -->
    <div class="fl-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-debt-schedule-mediaType_select"
          [(value)]="mediaType"
          disableOptionCentering
          multiple
          [placeholder]="'RESULTS.GENERAL.SELECT_MEDIA_TYPE' | anessaTranslation: trigger"
          (valueChange)="mediaTypeChanged()"
          panelClass="anessa-dropdown-panel">
          <mat-option *ngFor="let opt of mediaTypes"
                      [value]="opt.value"
          >{{opt.translationId | anessaTranslation: trigger}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Result Select -->
    <div class="fl-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-debt-schedule-result_select"
          disableOptionCentering
          [placeholder]="'RESULTS.GENERAL.SELECT_RESULTS' | anessaTranslation: trigger"
          multiple
          [(value)]="selectedResults"
          (valueChange)="mediaTypeChanged()"
          panelClass="anessa-dropdown-panel">
          <div class="dropdown-select-all-container">
            <mat-checkbox
              class="mat-option mat-option-multi"
              color="primary"
              (change)="inputsCheckAll($event)"
              [checked]="allInputsSelected()"
              [indeterminate]="isCheckAllIndeterminate()"
              #inputsCheckbox>
              {{ inputsCheckbox.checked ?
              ('RESULTS.GENERAL.DESELECT_ALL' | anessaTranslation: trigger) :
              ('RESULTS.GENERAL.SELECT_ALL' | anessaTranslation: trigger) }}
            </mat-checkbox>
          </div>
          <ng-container *ngFor="let result of resultOptions">
            <mat-option [value]="result">{{ result.displayName}}</mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Currency Select -->
    <div class="fl-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-debt-schedule-currency_select"
          [(value)]="selectedCurrency"
          [placeholder]="'RESULTS.GENERAL.SELECT_RESULTS' | anessaTranslation: trigger"
          disableOptionCentering
          (valueChange)="mediaTypeChanged()"
          panelClass="anessa-dropdown-panel">
          <mat-option disabled>
            {{'RESULTS.GENERAL.RATES_FROM' | anessaTranslation: trigger}}: {{ exchangeRateDate }}
          </mat-option>
          <mat-option
            *ngFor="let unit of currencyData"
            [value]="unit">{{ unit.translationId | anessaTranslation: trigger }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <!--END SELECTION BOXES-->
  <div class="fl" *ngIf="showGraph || showTable()">
    <p>{{'RESULTS.GENERAL.EXCHANGE_RATES_FROM' | anessaTranslation: trigger}} <i>{{ exchangeRateDate }}</i></p>
  </div>
  <!-- START TABLE -->
  <div *ngIf="showTable()">
    <results-treetable
      [resultsData]="tableData"
      [firstColumnHeader]="'RESULTS.GENERAL.YEARS' | anessaTranslation: trigger"
    ></results-treetable>
  </div>
  <!-- END TABLE -->

  <!-- START GRAPH -->
  <div class="row fl" *ngIf="showGraph">
    <div class="fl-item">
      <app-graph-selector
        [graphData]="graphData"
        [customLayout]="graphLayout"
        [yAxisLabel]="yAxisLabel"
        [xAxisLabel]="xAxisLabel"
        [graphType]="'raw'"
      ></app-graph-selector>
    </div>
  </div>
  <!-- END GRAPH -->
</div>
